import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss']
})
export class TextFieldComponent implements OnInit {
  profileTxtForm: FormGroup;
  @Input() filedInfo: any;
  @Output() textChanged: EventEmitter<any> = new EventEmitter<any>();
  textVal: any;
  get formControls() { return this.profileTxtForm.controls; }
  constructor(private formBuilder: FormBuilder,) { }

  ngOnInit(): void {
    let temp = [];
    for (let item of this.filedInfo) {
    }
    this.profileTxtForm  =  this.formBuilder.group({
      codeMelli: ['', Validators.required],
      lastName: ['', Validators.required]
    });
  }

}
